import { Logo } from '@planuze/ui';
import { useCommonContent } from '../content/sections/common.js';
import { useTheme } from './theme-provider.js';

/* Marca do backoffice (ADR-0700): banda alinhada à altura do header (h-14 + border-b) formando
   um topo coeso [logo | topbar]. Logo REAL da Planuze + chip "Admin"; variante pelo tema
   resolvido (data-theme do ThemeProvider). */
export function BrandLogo() {
  const { resolved } = useTheme();
  const copy = useCommonContent().brandLogo;
  return (
    <div className="flex h-14 shrink-0 items-center gap-2 border-b border-border px-5">
      <Logo variant={resolved === 'dark' ? 'white' : 'black'} className="h-6 w-auto" />
      <span className="rounded bg-muted px-1.5 py-0.5 text-[10px] font-semibold uppercase tracking-wider text-muted-foreground">
        {copy.adminChip}
      </span>
    </div>
  );
}
